
import { connect } from 'react-redux';
import { actionCreators as draftActionCreators} from 'app/area/case/draft/actions';
import { AuthState } from 'app/types-shared';

export const withSaveAsDraft = (component: any, uiEngineProps: any) => {
  const isAnonymous = uiEngineProps.sharedState.authState === AuthState.Anonymous;
  const dispatchToProps = (dispatch: any): Partial<any> => {
    return {
      onSaveAsDraft: async () => {
        await dispatch(draftActionCreators.saveAsDraft(isAnonymous));
      }
    };
  };

  return connect<any, any, any>(
    undefined,
    dispatchToProps
  )(component);
};
